import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'pl-form-unavailable',
  templateUrl: './form-unavailable.component.html',
  styleUrls: ['./form-unavailable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormUnavailableComponent {
  @Input() formName: string;
  @Input() i18nMessageKey: string;
}
